export default "__VITE_ASSET__121646ce__"